import {
  set_dto_Merchant,
  set_dto_selected_final_merchant_or_product,
  set_dto_selected_merchant_or_product,
} from "../../../../classes/dto-setters/dto-setter";
import {
  dto_selected_final_merchant_or_product,
} from "../../../../classes/dto-selected-merchant-or-product";
import { GET_CART_SELECT_MERCHATS_ZONE } from "../../../../database/get-stored-data";
import { PT_PRODUCT_LIST } from "../../../../routes/stack/paths/pt-home";
import { F_Fammily } from "../../../../util/config-fonts";
import { Colors } from "../../../../util/colors";
import { CSP } from "../../../../config/config";
import React from "react";

export default class BackToShop extends React.Component {
  componentDidMount() {}
  render() {
    return (
      <div>
        <div
          style={{
            textAlign: "center",
            marginTop: 6,
            width: "100%",
          }}
        >
          <button
            style={{
              textAlign: "center",
              height: "48px",
              width: "100%",
              display: "flex",
              fontFamily: F_Fammily.Medium,
              fontSize: 16,
              borderRadius: "4px",
              backgroundColor: Colors.DarkGreyScale,
              color: "white",
              border: "none",
              cursor: "pointer",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={async () => {
              const storedCartMerchant = await GET_CART_SELECT_MERCHATS_ZONE();
              const cartMerchant = {
                ...(storedCartMerchant || dto_selected_final_merchant_or_product),
                CATID:
                  CSP === "MK" &&
                  ((storedCartMerchant || dto_selected_final_merchant_or_product)
                    .CATID === 0 ||
                    (storedCartMerchant || dto_selected_final_merchant_or_product)
                      .CATID === undefined)
                    ? Number(localStorage.getItem("firstCATID")) || 1
                    : (storedCartMerchant || dto_selected_final_merchant_or_product)
                        .CATID,
              };
              await set_dto_Merchant(cartMerchant);
              await set_dto_selected_final_merchant_or_product(cartMerchant);
              await set_dto_selected_merchant_or_product(cartMerchant);
              this.props.navigate(
                PT_PRODUCT_LIST.replace(":navPage", "cart").replace(
                  ":isSec",
                  "false"
                )
              );
            }}
          >
            <i
              className="fa fa-shopping-cart"
              aria-hidden="true"
              style={{
                marginRight: 6,
                fontSize: "18px",
                display: "none",
              }}
            />
            SHOP MORE
          </button>
        </div>
      </div>
    );
  }
}
